import { Button, Grid, Typography } from "@mui/material";
import React from "react";
import "../assets/css/BoxButton.css";

const BoxButton = ({
  onNext,
  onPrevious,
  currentStep,
  startAgain,
  viewBoxButton,
  modality,
  urlParamsAml,
}) => {
  const isItalian =
    urlParamsAml === "fisico-eng" || urlParamsAml === "giuridico-eng";

  const texts = {
    back: !isItalian ? "Indietro" : "Back",
    reset: !isItalian ? "Azzera dati" : "Reset data",
    next: !isItalian ? "Avanti" : "Next",
    confirmAml: !isItalian ? "Conferma AML" : "Confirm AML",
    confirmCase: !isItalian ? "Conferma pratica" : "Confirm case",
  };

  return (
    <Grid
      container
      className="bg-blue-dark"
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
        padding: "15px 0px",
        display: "flex",
        justifyContent: {
          xs: "space-around",
          sm: "center",
        },
        alignItems: "center",
      }}
    >
      <Grid container className="container-box-button">
        <Grid item xs={6} md={6}>
          {viewBoxButton === false ? (
            <Button
              variant="outlined"
              onClick={currentStep === 5 ? startAgain : onPrevious}
              className={`button-bg-light ${
                currentStep === 1 ? "button-bg-light-disable" : ""
              }`}
              disabled={currentStep === 1}
              style={{ display: currentStep === 1 ? "none" : "block" }}
            >
              <Typography
                className="color-light"
                sx={{
                  textTransform: "initial",
                  fontSize: { xs: "16px", sm: "18px" },
                  fontWeight: 500,
                }}
              >
                {currentStep === 5 ? texts.reset : texts.back}
              </Typography>
            </Button>
          ) : null}
        </Grid>

        <Grid
          item
          xs={6}
          md={6}
          style={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            variant="contained"
            className="button-bg-purple"
            onClick={onNext}
          >
            <Typography
              className="color-light"
              sx={{
                textTransform: "initial",
                fontSize: { xs: "16px", sm: "18px" },
                fontWeight: 500,
              }}
            >
              {modality === "aml" && currentStep === 5
                ? texts.confirmAml
                : currentStep === 5
                ? texts.confirmCase
                : texts.next}
            </Typography>
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default BoxButton;
